import {
  Component, EventEmitter, Input, Output
} from '@angular/core';

@Component({
  selector: 'iris-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class IrisEmptyStateComponent {
  @Input() buttonText = '';
  @Input() details = '';
  @Input() imageSrc = '';
  @Input() title = '';
  @Output() onButtonClick = new EventEmitter<void>();

  handleButtonClick(): void {
    this.onButtonClick.emit();
  }
}
